import { Pipe, PipeTransform } from '@angular/core';
import {JsonPipe} from "@angular/common";

@Pipe({
  name: 'jsonOrEmpty'
})
export class JsonOrEmptyPipe extends JsonPipe {
  override transform(value: any): string {
    return value == null ? '-' : super.transform(value);
  }
}
